(function(window, document, $, undefined){




  
  return false;
// https://codepen.io/osublake/pen/a633d0c9e6e2b951496d7f1eb4fd8fb6?editors=0010

var triggerOffset = 0;//document.documentElement.clientHeight / 2; //
var sceneStart = 0;
var duration = 200;

var requestId = null;

// TweenLite.set(".box", {
//   left: 25,
//   top: 2100
// });

// TweenLite.set(".timeline-trigger", {
//   top: triggerOffset
// });

// TweenLite.set(".start-trigger", {
//   top: sceneStart
// });

// TweenLite.set(".end-trigger", {
//   top: sceneStart + duration
// });

// SCROLL MAGIC!!!
var tl = new TimelineMax({ paused: true });


  // .set(".box", { backgroundColor: "#64dd17" }, sceneStart)
  // .to(".box", duration, { rotation: 720, x: 300 }, sceneStart)
  // .set(".box", { backgroundColor: "red" })

// var logo = $('.site-header .site-title');

tl.set('h1.site-title',{top:-21,left:20,width:160,height:160}, sceneStart);
tl.to('h1.site-title',duration,{top:-14,left:20,width:80,height:80}, sceneStart);

tl.to('.site-header .site-header-left',duration/2,{autoAlpha:0}, sceneStart);
tl.to('.site-header .site-header-right',duration/2,{autoAlpha:0}, sceneStart);
tl.to('.site-header .site-header-left',duration,{marginTop:-64}, sceneStart);
tl.to('.site-header .site-header-right',duration,{marginTop:-64}, sceneStart);
tl.to('.site-header .main-navigation',duration,{height:40}, sceneStart);

// TimelineMax.play();

// Only update on animation frames
window.addEventListener("scroll", function() {
  if (!requestId) {
    requestId = requestAnimationFrame(update);
  }
});

update();

// Set timeline time to scrollTop
function update() {
  tl.time(window.pageYOffset + triggerOffset);
  requestId = null;
}




})(window, document, jQuery);